import { BellOutlined } from "@ant-design/icons";
import { Badge, Button, Divider, Popover, Space, Spin } from "antd";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { getStore } from "../utils/global";
import axios from "../utils/axios";

export default function Notifications() {
  const [open, setOpen] = useState(false);
  const user = getStore("user");
  const { data, isFetching, refetch } = useQuery({
    queryKey: ["get_notifs", user?.kdss_user],
    queryFn: () => axios.get("/client/api/notification/list"),
    enabled: open,
    select: ({ data }) => data?.list || [],
  });

  const { data: count, refetch: refetchCount } = useQuery({
    queryKey: ["unread_notif_count", user?.kdss_user],
    queryFn: () => axios.get("/client/api/notification/unread-count"),
    select: ({ data }) => data?.unread_count || 0,
    staleTime: 0,
    refetchOnMount: true,
  });
  return (
    <Popover
      trigger="click"
      content={
        <NotificationList
          isLoading={isFetching}
          list={data}
          refetch={() => {
            refetchCount();
            refetch();
          }}
          onClose={() => setOpen(false)}
        />
      }
      open={open}
      onOpenChange={() => setOpen((p) => !p)}>
      <Badge count={count || 0}>
        <Button shape="circle" icon={<BellOutlined />} style={{ marginLeft: 20 }} />
      </Badge>
    </Popover>
  );
}

const NotificationList = ({ isLoading, list = [], refetch, onClose }) => {
  const { mutate } = useMutation({
    mutationKey: ["read_notif"],
    mutationFn: (id) => axios.post(`/client/api/notification/read`, { notification_id: id }),
    onSuccess: () => refetch(),
  });
  const { mutate: readAll, isLoading: readLoading } = useMutation({
    mutationKey: ["read_all_notifs"],
    mutationFn: () => axios.post(`/client/api/notification/read-all`),
    onSuccess: () => {
      refetch();
      onClose();
    },
  });
  const history = useHistory();

  return (
    <Spin spinning={isLoading}>
      <Space style={{ width: "100%", justifyContent: "end" }}>
        <Button onClick={readAll} type="primary" size="small" loading={readLoading}>
          Read all
        </Button>
      </Space>
      <Divider />
      <div className="notif_container">
        {list?.map((notif, i) => (
          <div
            className="notif_item"
            key={`notif_item_${i}`}
            style={{ backgroundColor: !notif?.is_read ? "#7ea8f047" : "transparent" }}
            onClick={() => {
              if (!notif?.is_read) {
                mutate(notif?.id);
              }
              if (notif?.link) {
                history.push(notif.link);
              }
              onClose();
            }}>
            <div style={{ flexGrow: 1 }}>
              <b>{notif?.title}</b>
              <p>{notif?.body}</p>
              <p style={{ fontSize: 10, textAlign: "end" }}>
                {moment().diff(notif?.created_at.date, "days") > 1
                  ? moment(notif?.created_at.date).format("YYYY-MM-DD HH:mm:ss")
                  : moment(notif?.created_at.date).fromNow()}
              </p>
            </div>
            {!notif?.is_read && <Badge status="error" />}
          </div>
        ))}
      </div>
    </Spin>
  );
};
